// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.create-task-main {
  margin-left: 2vw;
  display: flex;
  flex-direction: column;
  flex: 0.75 1;
  margin-right: 2vw;
  margin-top: 20px;
}

.ant-modal-body::-webkit-scrollbar {
  display: none;
}

.custom-input {
  border-bottom: 1px solid #d9d9d9;
  border-radius: 0;
}

.ant-select-selector {
  border: none;
  border-bottom: 1px solid #ccc;
}

/* .ant-select-focused .ant-select-selector {
    box-shadow: none;
  } */
/* .custom_select{
    border: none;
    border-bottom: 1px solid #ccc;
    border-radius: 0;
    box-shadow: none;
    width: 100%;
  } */
.ant-input {
  /* border: none; */
  border-bottom: 1px solid #ccc;
}

.ant-input:hover,
.ant-input:focus {
  border-color: #ccc;
  box-shadow: none;
}

.todolist_checkbox {
  display: flex;
  flex-direction: column;
}

.checkbox .ant-checkbox-inner {
  width: 25px;
  height: 25px;
  border-radius: 0px;
  /* line-height: 20px; */
}

.ant-card-head {
  border-bottom: none;
}

.divider .ant-divider-horizontal {
  margin: 16px 0px;
}

@media (min-width: 320px) {
  .ant-modal .ant-modal-content {
    border-radius: 0;
    padding: 0;
  }

  .ant-modal .ant-modal-title {
    color: #003399;
    background: #D2E1FF;
    padding: 15px;
  }

  .ant-modal .ant-modal-footer {
    background: #ccc;
    padding: 15px;
    text-align: center;
    display: flex;
    justify-content: center;
  }

  .ant-modal-footer {
    text-align: center;
    background-color: #ccc;
    padding: 0px;
  }

  .ant-modal-footer .ant-btn {
    border-radius: 2px;
    position: relative;
    cursor: pointer;
    border-width: 1.2px;
    margin-right: 8px;
    display: inline-flex;
    justify-content: center;
  }

  .event_form_header {
    font-size: 15px;
    /* font-family: roboto; */
    font-weight: 700;
  }
}

.tab-listing .ant-tabs-tab-btn {
  color: #28B1FF !important;
}`, "",{"version":3,"sources":["webpack://./src/pages/actions/CreateTask.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,YAAU;EACV,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;;KAEK;AACL;;;;;;KAMK;AACL;EACE,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,gBAAgB;IAChB,UAAU;EACZ;;EAEA;IACE,cAAc;IACd,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;IACpB,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,yBAAyB;IACzB,gBAAgB;EAClB;AACF;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".create-task-main {\n  margin-left: 2vw;\n  display: flex;\n  flex-direction: column;\n  flex: 0.75;\n  margin-right: 2vw;\n  margin-top: 20px;\n}\n\n.ant-modal-body::-webkit-scrollbar {\n  display: none;\n}\n\n.custom-input {\n  border-bottom: 1px solid #d9d9d9;\n  border-radius: 0;\n}\n\n.ant-select-selector {\n  border: none;\n  border-bottom: 1px solid #ccc;\n}\n\n/* .ant-select-focused .ant-select-selector {\n    box-shadow: none;\n  } */\n/* .custom_select{\n    border: none;\n    border-bottom: 1px solid #ccc;\n    border-radius: 0;\n    box-shadow: none;\n    width: 100%;\n  } */\n.ant-input {\n  /* border: none; */\n  border-bottom: 1px solid #ccc;\n}\n\n.ant-input:hover,\n.ant-input:focus {\n  border-color: #ccc;\n  box-shadow: none;\n}\n\n.todolist_checkbox {\n  display: flex;\n  flex-direction: column;\n}\n\n.checkbox .ant-checkbox-inner {\n  width: 25px;\n  height: 25px;\n  border-radius: 0px;\n  /* line-height: 20px; */\n}\n\n.ant-card-head {\n  border-bottom: none;\n}\n\n.divider .ant-divider-horizontal {\n  margin: 16px 0px;\n}\n\n@media (min-width: 320px) {\n  .ant-modal .ant-modal-content {\n    border-radius: 0;\n    padding: 0;\n  }\n\n  .ant-modal .ant-modal-title {\n    color: #003399;\n    background: #D2E1FF;\n    padding: 15px;\n  }\n\n  .ant-modal .ant-modal-footer {\n    background: #ccc;\n    padding: 15px;\n    text-align: center;\n    display: flex;\n    justify-content: center;\n  }\n\n  .ant-modal-footer {\n    text-align: center;\n    background-color: #ccc;\n    padding: 0px;\n  }\n\n  .ant-modal-footer .ant-btn {\n    border-radius: 2px;\n    position: relative;\n    cursor: pointer;\n    border-width: 1.2px;\n    margin-right: 8px;\n    display: inline-flex;\n    justify-content: center;\n  }\n\n  .event_form_header {\n    font-size: 15px;\n    /* font-family: roboto; */\n    font-weight: 700;\n  }\n}\n\n.tab-listing .ant-tabs-tab-btn {\n  color: #28B1FF !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
